import React from "react";
import "../../Styles/Settings/PresenctionSetting.css";

const Presenction = () => {
  return (
    <>
      <div className="response-setting-container">
        <div className="text-head">
          Manage how the form and responses are presented
        </div>
        <div className="response-presenction">
          <div style={{ color: "#8493B2" }}>FORM PRESENTATION</div>
          <div className="encrypt-data-container">
            <div className="text-container-setting">
              <div className="text-head">Show progress bar</div>
              <div className="text-des">
                Lorem Ipsum has been the industry's standard dummy text ever
                since
              </div>
            </div>
            <div>
              <label class="form-setting-switch">
                <input type="checkbox" />
                <span class="form-setting-slider form-setting-round"></span>
              </label>
            </div>
          </div>
          <div className="encrypt-data-container">
            <div className="text-container-setting">
              <div className="text-head">Shuffle question order</div>
              <div className="text-des">
                Lorem Ipsum has been the industry's standard dummy text ever
                since
              </div>
            </div>
            <div>
              <label class="form-setting-switch">
                <input type="checkbox" />
                <span class="form-setting-slider form-setting-round"></span>
              </label>
            </div>
          </div>
          <div className="encrypt-data-container">
            <div className="text-container-setting">
              <div className="text-head">View results summary</div>
              <div className="text-des">
                Share results summary with respondents. Important details
              </div>
            </div>
            <div>
              <label class="form-setting-switch">
                <input type="checkbox" />
                <span class="form-setting-slider form-setting-round"></span>
              </label>
            </div>
          </div>
        </div>
        <div className="bottom-container-Disable-container">
          <div style={{ color: "#8493B2" }}>RESTRICTIONS:</div>
          <div className="bottom-container-Disable">
            <div>Disable auto-save for all respondents</div>
            <div>
              <label class="form-setting-switch">
                <input type="checkbox" />
                <span class="form-setting-slider form-setting-round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          paddingRight: "2rem",
          marginBottom: "3rem",
        }}
      >
        <button className="save-btn-form-response-setting">Save</button>
      </div>
    </>
  );
};

export default Presenction;
